import React, { useState, useEffect } from "react";
import SmallBanner from '../components/smallBanner';
import { ReactComponent as ExploreArrow } from '../assets/icons/double-arrow.svg';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { BASE_URL, GET_PRODUCT_BY_ID, GET_PRODUCT_TYPE } from "../ApiUrl";

const ProductView = () => {
    const [activeTab, setActiveTab] = useState(null); // Updated to handle dynamic tabs
    const [products, setProducts] = useState([]);
    const [productlist, setProductlist] = useState([]);
     const [searchQuery, setSearchQuery] = useState("");
    const location = useLocation();
    const { item } = location.state || {}; // Safely handle location.state
    const productTypeId = item?.id || null; // Safely extract productTypeId

    // console.log(item, "itemitemitemitem");

    // Function to change active tab
    const handleTabClick = (tabId) => {
        // console.log(tabId, "tabID");
        setActiveTab(tabId);
    };

    // Fetch products based on activeTab (dynamic handling for productTypeId)
    const fetchProducts = async (productTypeId) => {
        if (!productTypeId) return;

        try {
            const response = await axios.get(BASE_URL + GET_PRODUCT_BY_ID, {
                params: { productTypeId },
            });
            setProducts(response.data.products || []); // Handle empty response safely
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    useEffect(() => {
        if (activeTab) {
            fetchProducts(activeTab); // Fetch products for active tab
        }
    }, [activeTab]);

    const fetchProductTypes = async () => {
        try {
            const result = await axios.get(BASE_URL + GET_PRODUCT_TYPE);
            const productTypes = result.data.productTypes || [];
            setProductlist(productTypes);

            // Set the active tab to the initial `item.productTypeId` or the first productType
            if (productTypeId) {
                setActiveTab(productTypeId);
            } else if (productTypes.length > 0) {
                setActiveTab(productTypes[0].id);
            }
        } catch (error) {
            console.error('Error fetching product types:', error);
        }
    };

    useEffect(() => {
        fetchProductTypes(); // Fetch product types on component mount
    }, []);

    const filteredProducts = products ? products.filter(product => 
        product?.productname?.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    // console.log(products, "products");
    // console.log(productlist, "productlist");

    return (
        <main className="product-view-page">
            <SmallBanner Heading={'Our Products'} />
            <section className="product-tab-wrapper py-100 pb-0">
                <div className="container">
                    <div className="row position-relative">
                        {/* Left Tabs */}
                        <div className="col-lg-4">
                            <div className="left-tab">
                                {productlist && productlist.length > 0 ? productlist.map((productType) => {
                                    return (
                                        <h3 key={productType.id} className={`link-wrapper ${activeTab === productType.id ? "active" : ""}`} onClick={() => handleTabClick(productType.id)}>
                                            {productType.typename}
                                            <span>
                                                <ExploreArrow className="next-icon" />
                                            </span>
                                        </h3>
                                    );
                                }) : (
                                    <div>
                                        <p className="text-center">No Product  available</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="col-lg-8">
                            <div className="right-tab" data-aos="fade-in" data-aos-duration="3000">
                                 <div className="d-flex justify-content-start mb-4">
                                    <div className="search-wrap position-relative shadow-sm bg-white" style={{ width: "100%", maxWidth: "450px", borderRadius: "50px", overflow: 'hidden' }}>
                                        <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            style={{ padding: "12px 40px 12px 20px", boxShadow: "none" }}
                                            placeholder="Search Products..." 
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <span className="position-absolute" style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', color: '#102A6F' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                                            </svg>
                                        </span>
                                    </div>
                                </div>

                                {activeTab && (
                                    <div className="product-content">
                                        <h4 className="product-heading-small">
                                            {productlist.find((type) => type.id === activeTab)?.typename} List
                                        </h4>
                                        <table className="table table-bordered pro-table w-100">
                                            <thead>
                                                <tr>
                                                    <th>Sr</th>
                                                    <th>Product Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredProducts && filteredProducts.length > 0 ? filteredProducts.map((value, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{value.productname}</td>
                                                        </tr>
                                                    );
                                                }) : (
                                                    <tr className="text-center">
                                                        <td colSpan="2" className="text-center py-3">No Product available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default ProductView;


